const initialState = {
    mapKey: ''
  };
  
  const mapkeyReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_MAP_KEY':
            return { ...state, mapKey: action.payload };
        default:
            return state;
    }
  };
  
  export default mapkeyReducer;
  